/* ==========================================================
   TEASCATO LANDING — JavaScript
   Shopify Theme Asset: assets/teascato-landing.js
   ========================================================== */

(function () {
  'use strict';

  /* ── Age Gate ── */
  const AGE_KEY = 'teascato_age_ok';

  function initAgeGate() {
    const gate = document.getElementById('ageGate');
    if (!gate) return;

    if (sessionStorage.getItem(AGE_KEY)) {
      gate.remove();
      return;
    }

    document.body.style.overflow = 'hidden';

    document.getElementById('age-gate-yes')?.addEventListener('click', () => {
      sessionStorage.setItem(AGE_KEY, '1');
      gate.classList.add('gone');
      document.body.style.overflow = '';
      setTimeout(() => gate.remove(), 500);
    });

    document.getElementById('age-gate-no')?.addEventListener('click', () => {
      window.location.href = 'https://www.responsibility.org/';
    });
  }

  /* ── Ticker — duplicate inner content for seamless loop ── */
  function initTicker() {
    const inner = document.getElementById('lp-ticker-inner');
    if (!inner) return;
    // Duplicate so the CSS animation loops seamlessly
    inner.innerHTML += inner.innerHTML;
  }

  /* ── Scroll Reveal ── */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('visible'), 80 * i);
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
  }

  /* ── AJAX Add to Cart ── */
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', async function () {
        const variantId = this.dataset.variantId;

        if (!variantId || variantId === 'VARIANT_ID') {
          // No variant configured — fall back to cart page
          window.location.href = '/cart';
          return;
        }

        const originalText = this.textContent;
        this.textContent = 'Adding…';
        this.style.opacity = '0.7';
        this.style.pointerEvents = 'none';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
          });

          if (!res.ok) throw new Error('Cart error');

          const item = await res.json();
          showCartToast(item.title || 'Item added!');
          updateCartCount();

        } catch (err) {
          console.warn('[Teascato] Add to cart failed:', err);
          window.location.href = '/cart';
        } finally {
          this.textContent = originalText;
          this.style.opacity = '';
          this.style.pointerEvents = '';
        }
      });
    });
  }

  /* ── Cart Toast Notification ── */
  function showCartToast(itemName) {
    const el = document.getElementById('cart-notification');
    const txt = document.getElementById('cart-notification-text');
    if (!el) return;
    if (txt) txt.textContent = `${itemName} added!`;
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('show');
    setTimeout(() => {
      el.classList.remove('show');
      el.setAttribute('aria-hidden', 'true');
    }, 4000);
  }

  /* ── Update cart count badge ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch (_) { /* silent */ }
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', () => {
    initAgeGate();
    initTicker();
    initScrollReveal();
    initAddToCart();
    updateCartCount();
  });

})();
